import { render, staticRenderFns } from "./RemoveDocumentModal.vue?vue&type=template&id=ef88ea52"
import script from "./RemoveDocumentModal.vue?vue&type=script&lang=ts"
export * from "./RemoveDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef88ea52')) {
      api.createRecord('ef88ea52', component.options)
    } else {
      api.reload('ef88ea52', component.options)
    }
    module.hot.accept("./RemoveDocumentModal.vue?vue&type=template&id=ef88ea52", function () {
      api.rerender('ef88ea52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/RemoveDocumentModal.vue"
export default component.exports